import { _sharedActionsConstantsSystem } from "./actions";
import { isOnLine } from "../../utils/user-agent";

export const _sharedStateSystem = {
  isLogin: false,
  isTopPanelVisible: true,
  loaders: [],
  messages: [],
  onLine: isOnLine() ?? false,
  dataAcquisitionStatus: undefined,
  userInfo: null,
  avatarLastUpdateTimestamp: Date.now(),
};

export const _sharedReducerSystem = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsSystem.UPDATE_DATA_ACQUISITION_STATUS: {
      return { ...state, dataAcquisitionStatus: action.data };
    }
    case _sharedActionsConstantsSystem.LOADING: {
      const { loadingId, forceRemove, forceAdd } = action.data;
      const loaders = [...state.loaders];

      const index = loaders.findIndex((item) => item === loadingId);

      if (forceAdd) {
        if (index === -1) {
          loaders.push(loadingId);
        }
      } else if (forceRemove) {
        if (index !== -1) {
          loaders.splice(index, 1);
        }
      } else if (index === -1) {
        loaders.push(loadingId);
      } else {
        loaders.splice(index, 1);
      }

      return { ...state, loaders };
    }
    case _sharedActionsConstantsSystem.TOAST:
      return { ...state, messages: [action.data, ...state.messages] };
    case _sharedActionsConstantsSystem.TOAST_SUCCESS:
      return { ...state, messages: state.messages.filter((m) => m !== action.data) };
    case _sharedActionsConstantsSystem.SET_IS_ONLINE:
      return { ...state, onLine: action.data };
    case _sharedActionsConstantsSystem.SET_IS_LOGIN: {
      return { ...state, isLogin: action.data };
    }
    case _sharedActionsConstantsSystem.SET_USER_INFO: {
      return { ...state, userInfo: action.data };
    }
    case _sharedActionsConstantsSystem.SET_AVATAR_LAST_UPDATE_TIMESTAMP: {
      return { ...state, avatarLastUpdateTimestamp: action.data };
    }
    case _sharedActionsConstantsSystem.SET_TOP_PANEL_VISIBILITY: {
      return { ...state, isTopPanelVisible: action.data };
    }
    default:
      return state;
  }
};
